module.exports = __webpack_public_path__ + "static/media/07-kor.1367c742.png";